import TemplateTagsDialog from "./TemplateTagsDialog";

export default TemplateTagsDialog